/**
 * HMAC-SHA256 of `body` under `secret`, hex encoded: what the backend expects
 * in the webhook signature header (backend/app/integrations/ezyvet/webhooks.py).
 * Runs in the browser with WebCrypto; the secret is never sent anywhere.
 */
export async function hmacSha256Hex(secret: string, body: string): Promise<string> {
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey("raw", enc.encode(secret), { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
  const sig = await crypto.subtle.sign("HMAC", key, enc.encode(body));
  return Array.from(new Uint8Array(sig), (b) => b.toString(16).padStart(2, "0")).join("");
}
